import compose from 'recompose/compose';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from 'moment-timezone';
import mapProps from 'recompose/mapProps';
import withHandlers from 'recompose/withHandlers';
import withState from 'recompose/withState';
import lifecycle from 'recompose/lifecycle';
import path from 'ramda/es/path';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router';

import { APP_ACCESS } from 'app/common/constants/services';
import { getIsAppConnected } from '../../../selectors/applications';
import Passages from '../../../components/Apps/Passages';
import * as passagesActions from '../../../actions/passages';
import selectHeader from './selectHeader';


const app = APP_ACCESS;

export default compose(
  withRouter,

  withTranslation('passes'),

  connect(
    (state, props) => {
      const { params: { id } } = props;
      const isConnected = getIsAppConnected(state, { id, app });
      const isExternalAvailable = !!path(['students', 'data', id, 'passagesExternalService'], state);
      return ({
        count: state.passages.data.count || 0,
        perPageItems: state.settings.passages.rows,
        isSubscribed: isConnected || isExternalAvailable,
        isExternal: !isConnected && isExternalAvailable,
        isPagination: state.settings.passages.rows < state.passages.data.count,
        loading: state.passages.opts.loading,
        header: selectHeader(state, props),
      });
    },
    dispatch => ({
      actions: bindActionCreators(passagesActions, dispatch),
      dispatch,
    })
  ),

  // постраничная навигация
  withState('page', 'setPage', 1),
  withHandlers({
    handleChangePage: ({ setPage }) => (page) => {
      setPage(page);
    },
  }),
  mapProps(({ page, perPageItems, count, ...others }) => {
    const left = count - ((page - 1) * perPageItems);
    return ({
      page,
      perPageItems,
      count,
      begin: ((page - 1) * perPageItems) + 1,
      N: left > perPageItems ? perPageItems : left,
      ...others,
    });
  }),

  // props, не зависящие от store
  mapProps((props) => {
    const {
      params: { date, date2 },
      location: { pathname },
      header,
    } = props;
    const dateMoment = moment(date);
    const dateMoment2 = date2 && moment(date2);

    const sDate = !date2
      ? moment(date).format('L')
      : `${dateMoment.format('L')} — ${dateMoment2.format('L')}`;

    const baseUrl = pathname.split('/').slice(0, 4);
    // const urlPrev = [
    //   ...baseUrl,
    //   dateMoment.clone().subtract(1, 'day').format('YYYY-MM-DD'),
    //   date2 && dateMoment2.clone().subtract(1, 'day').format('YYYY-MM-DD')
    // ].join('/');
    const urlPrev = baseUrl.concat(
      dateMoment.clone().subtract(1, 'day').format('YYYY-MM-DD'),
      date2 && dateMoment2.clone().subtract(1, 'day').format('YYYY-MM-DD')
    ).join('/');
    const urlNext = baseUrl.concat(
      dateMoment.clone().add(1, 'day').format('YYYY-MM-DD'),
      date2 && dateMoment2.clone().add(1, 'day').format('YYYY-MM-DD')
    ).join('/');
    const isDisabledNext = !!(dateMoment.isSame(moment(), 'day')
      || (date2 && dateMoment2.isSame(moment(), 'day')));

    return ({
      header,
      sDate,
      baseUrl,
      urlPrev,
      urlNext,
      isDisabledNext,
      ...props, // TODO убрать, когда не будут нужны
    });
  }),


  // withState('windowHeight', 'setWinHeight', window.innerHeight),


  withHandlers({
    // выбор даты
    handleDisabledDaysInDatePicker: () => day => moment(day).isAfter(moment(), 'day'),
    handleChangeDay: ({ baseUrl, router }) => day =>
      router.push([...baseUrl, moment(day).format('YYYY-MM-DD')].join('/')),
    handleChangeRange: ({ baseUrl, router }) => range =>
      router.push([
        ...baseUrl,
        moment(range.from).format('YYYY-MM-DD'),
        moment(range.to).format('YYYY-MM-DD'),
      ].join('/')),

    // изменение размеров окна
    // handleWindowResize: ({ windowHeight, setWinHeight }) => () => {
    //   const newHeight = window.innerHeight;
    //   if (windowHeight !== newHeight) {
    //     setWinHeight(newHeight);
    //   }
    // },

  }),

  //
  // mapProps((props) => {
  //   console.log(props);
  //   return props;
  // }),


  lifecycle({
    componentDidMount() {
      const { actions, params: { id, date, date2 }, perPageItems, page } = this.props;
      actions.fetchPassages(id, date, date2, (page - 1) * perPageItems, perPageItems);
      // размеры видимой области окна для прикрепления постраничной навигации к низу
      window.addEventListener('resize', this.props.handleWindowResize, true);
    },

    // $FlowFixMe
    UNSAFE_componentWillReceiveProps(nextProps) {
      const { actions, params: { id, date, date2 }, perPageItems, page } = this.props;
      const {
        params: { id: nextId, date: nextDate, date2: nextDate2 },
        perPageItems: nextPerPage,
        page: nextPage,
        handleChangePage,
      } = nextProps;

      if (
        nextPerPage !== perPageItems
        || nextId !== id
        || nextDate !== date
        || nextDate2 !== date2
        || nextPerPage !== perPageItems
      ) {
        handleChangePage(1);
        actions.fetchPassages(nextId, nextDate, nextDate2, 0, nextPerPage);
      }
      if (nextPage !== page) {
        actions.fetchPassages(
          nextId,
          nextDate,
          nextDate2,
          (nextPage - 1) * nextPerPage,
          nextPerPage
        );
      }
    },

    componentWillUnmount() {
      window.removeEventListener('resize', this.props.handleWindowResize, true);
    },
  })
)(Passages);
